// Emblème « aiguille et fil » d'AEF Retouches, redessiné en SVG à partir
// du scan de l'affiche des horaires (le README du handoff recommande de
// « refaire proprement le logo en SVG », le PNG d'origine étant un
// recadrage sur fond blanc). Une aiguille en diagonale, le fil qui passe
// dans le chas et boucle autour d'elle.
//
// `currentColor` : il suit la couleur du texte de l'endroit où il est posé
// (encre sur crème dans le bloc Horaires). Remplacé par l'image téléversée
// (`emblem_image`) si l'admin préfère son scan.
export default function NeedleEmblem({ className = "", style }) {
  return (
    <svg
      viewBox="0 0 440 180"
      className={className}
      style={style}
      role="img"
      aria-label="Aiguille et fil, emblème AEF Retouches"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Fil : boucle principale autour de l'aiguille, puis les deux brins. */}
      <path
        strokeWidth="2.2"
        d="M118 24 C 84 22, 62 58, 96 104 C 128 146, 214 148, 262 118 C 302 92, 300 52, 258 40 C 214 28, 168 60, 176 106 C 182 142, 236 158, 292 150"
      />
      <path strokeWidth="2.2" d="M118 24 C 138 8, 168 14, 176 34 C 184 54, 160 66, 150 52" />
      <path strokeWidth="2.2" d="M292 150 C 318 146, 330 128, 322 112 C 314 96, 296 100, 300 116" />
      <path strokeWidth="2" d="M96 104 C 70 118, 44 108, 40 92" />
      {/* Aiguille : corps effilé de la pointe (haut gauche) au chas (bas droite). */}
      <path
        fill="currentColor"
        stroke="none"
        d="M40 30 L 396 156 C 402 158, 402 166, 396 168 L 388 170 C 384 171, 380 169, 377 166 L 40 30 Z"
      />
      {/* Chas, évidé dans la tête. */}
      <ellipse cx="386" cy="162" rx="7" ry="3.2" transform="rotate(20 386 162)" fill="rgb(var(--c-cream, 250 247 241))" stroke="none" />
    </svg>
  );
}
